const products = {
    products: {
        HaifaStimBooster: "Accelera l`attività metabolica in situazioni di stress",
        HaifaStimEnergy: "Migliora l`equilibrio energetico della pianta",
        HaifaStimForce: "Risparmia l`energia metabolica supportando la sintesi proteica e aminoacida",
        HaifaStimHumiK: "Sostiene l`attività delle radici e l`assorbimento dei nutrienti",
        HaifaStimVigor: "Rafforza e migliora la resistenza della pianta rispetto agli stress abiotici",
        HaifaStimVIM: "Migliora la fertilità del suolo e l`efficienza dell`utilizzo dei nutrienti",
        HaifaStimVital: "Migliora le prestazioni della pianta",
        HaifaStimWallUp:
            "Miscela ottimale di micronutrienti selezionati per migliorare la resistenza della pianta agli stress abiotici; migliora la crescita e massimizza la resa",
        HaifaMicroCombi:
            "Una miscela stabile: solubile in acqua e non polverosa di chelati: Ferro: Manganese: Rame: Zinco - sono tutti presenti come forma chelata EDTA sodico",
        PolyFeedFoliar1:
            "Poly-Feed™ Foliar nutre le piante rispondendo ai loro precisi bisogni durante le fasi critiche di crescita: per assicurare massima resa e ottima qualità",
        PolyFeedFoliar2: "Formula specifica per la coltura",
        PolyFeedStim: "combinazione unica di biostimolanti naturali ed elementi minerali",
        HaifaBonus:
            "Le formule di fertilizzanti ad alto contenuto in potassio per un`efficiente applicazione fogliare si basano sul nitrato di potassio Multi-K™ di Haifa. ",
    },
};

export default products;
